import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";

const CustomersPage = lazy(() => import("@/modules/customers/pages/CustomersPage").then(module => ({ default: module.CustomersPage })));

export const customersRoutes: RouteObject[] = [
  {
    path: "customers",
    element: <RouteSuspense><CustomersPage /></RouteSuspense>,
  },
];
